import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// SA-8637: Sentry is loaded from CDN (see src/index.html). `Sentry` is a
// global declared in src/types/sentry-cdn.d.ts — do NOT import it from
// '@sentry/browser' at value position (webpack 4 cannot parse v10 ESM).
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import 'hammerjs';

// SA-8637: defensive guard — `Sentry` is populated by the CDN <script> in
// index.html. If that script failed to load (network / CSP / blocked), skip
// init rather than crash bootstrap.
if (environment.sentry.dsn && typeof Sentry !== 'undefined') {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.environment,
    enableLogs: true,
    maxBreadcrumbs: 30,
    ignoreErrors: [
      // Browser / rendering noise
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      // Chunk loading (transient network issues)
      'Loading chunk',
      'ChunkLoadError',
      // Browser extension errors
      'Extension context invalidated',
      // Non-actionable Angular zone errors
      "Cannot read properties of null (reading 'nativeElement')",
      "Cannot read property 'nativeElement' of null"
    ],
    denyUrls: [
      // Browser extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      // Analytics / third-party
      /hotjar\.com/i
    ],
    beforeSend(event) {
      // Always allow explicitly tagged events through (e.g. script-loader, effects, auth)
      if (event.tags && event.tags['source']) {
        return event;
      }

      // Drop untagged events without a stacktrace (usually noise from global handler)
      if (
        event.exception &&
        event.exception.values &&
        event.exception.values.length > 0
      ) {
        const hasStacktrace = event.exception.values.some(
          (v) =>
            v.stacktrace &&
            v.stacktrace.frames &&
            v.stacktrace.frames.length > 0
        );
        if (!hasStacktrace) {
          return null;
        }
      }
      return event;
    }
  });

  Sentry.setTag('clinic', window.location.hostname.split('.')[0]);
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
